import Vue from "vue";
import App from "./App.vue";
import router from "../../router/pc/index";
import store from "../../store";

import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";
Vue.use(VueAwesomeSwiper /* { default options with global component } */);

import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(Element);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);
import zh from "../../lang/zh";
import en from "../../lang/en";
import sp from "../../lang/spain";
let lang = localStorage.getItem("lang");
if (lang === "zh" || lang === "en" || lang === "sp") {
  lang = localStorage.getItem("lang");
} else {
  lang = "en";
}

const i18n = new VueI18n({
  locale: lang,
  messages: {
    zh, // 中文语言包
    en, // 英文语言包
    sp // 西班牙语言包
  }
});

import VueAMap from "vue-amap";
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: "89ce1e26b767aa9d37494ad03e9a019f",
  plugin: [
    "Autocomplete",
    "PlaceSearch",
    "Scale",
    "OverView",
    "ToolBar",
    "MapType",
    "PolyEditor",
    "AMap.CircleEditor"
  ],
  v: "1.4.4",
  uiVersion: "1.0"
});

import { rewirteLog } from "../../utils/utils";
rewirteLog();

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
